<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Department of Production Planning/ ແຈ້ງເຕືອນສະພາບອາກາດ
            
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid==3" >
        <b-tab-item label="ຕັ້ງຄ່າແຈ້ງເຕືອນ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ຕັ້ງຄ່າແຈ້ງເຕືອນ">
              </b-field>
  
                <br>
                <div class="columns">
                  <b-field label="ວັນທີແຈ້ງເຕືອນ">
                        <b-datepicker
                          :date-formatter="dateFormatter"
                          v-model="selectednotidate"
                        >
                        </b-datepicker>
                      </b-field>
                </div>
                <br>
                <div class="columns">
                  <b-field label="ວັນທີມີຜົນ">
                        <b-datepicker
                          :date-formatter="dateFormatter"
                          v-model="selectedeffectdate"
                        >
                        </b-datepicker>
                      </b-field>
                </div>
                <br>
              
                  <b-field label="ລາຍລະອຽດ">
                    <b-input maxlength="1000" v-model.trim="notiremark"  type="textarea" placeholder="ລາຍລະອຽດ"></b-input>
                  </b-field>
                <div class="columns">
                  <b-field>
                    <button
                      class="button is-info"
                      @click="saveWeatherNoti"
                    >
                      ບັນທຶກ
                    </button>
                  </b-field>
                </div>
         
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="ເຕືອນແລ້ວ ທີ່ຕັ້ງຄ່າແລ້ວ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ລາຍການ ເຕືອນແລ້ວ ທີ່ຕັ້ງຄ່າແລ້ວ">
              </b-field>
              <b-field>
                <table
                  class="table is-fullwidth is-narrow is-small"
                >
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="2%">#</th>
                      <th class="has-text-left " width="10%">
                        ວັນທີຕັ້ງຄ່າ
                      </th>
                      <th class="has-text-left " width="10%">
                        ວັນທີແຈ້ງເຕືອນ
                      </th>
                      <th class="has-text-left " width="10%">
                        ວັນທີມີຜົນ
                      </th>
                      <th class="has-text-left " width="40%">
                        ລາຍລະອຽດ
                      </th>
                      <th class="has-text-left " width="10%">
                        ຊາວກະສິກອນ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in plantnotisetup"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ dateFormatter(data.SETUPDATE) }}
                      </td>
                      <td>
                        {{  dateFormatter(data.NOTIDATE) }}
                      </td>
                      <td>
                        {{  dateFormatter(data.EFFECTDATE) }}
                      </td>
                      <td class="has-text-left">
                        {{ data.REMARK }}
                      </td>
                      <td>
                        {{ data.FARMNAME }}<br>{{ data.FARMERID}}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="ແຈ້ງເຕືອນ ທີ່ສົ່ງອອກໄປແລ້ວ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ລາຍການ ແຈ້ງເຕືອນ ທີ່ສົ່ງອອກໄປແລ້ວ">
              </b-field>
              <b-field>
                <table
                  class="table is-fullwidth is-narrow is-small"
                >
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="2%">#</th>
                      <th class="has-text-left " width="10%">
                        ວັນທີຕັ້ງຄ່າ
                      </th>
                      <th class="has-text-left " width="10%">
                        ວັນທີແຈ້ງເຕືອນ
                      </th>
                      <th class="has-text-left " width="10%">
                        ວັນທີມີຜົນ
                      </th>
                      <th class="has-text-left " width="40%">
                        ລາຍລະອຽດ
                      </th>
                      <th class="has-text-left " width="10%">
                        ຊາວກະສິກອນ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in plantnotisend"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ dateFormatter(data.SETUPDATE) }}
                      </td>
                      <td>
                        {{  dateFormatter(data.NOTIDATE) }}
                      </td>
                      <td>
                        {{  dateFormatter(data.EFFECTDATE) }}
                      </td>
                      <td class="has-text-left">
                        {{ data.REMARK }}
                      </td>
                      <td>
                        {{ data.FARMNAME }}<br>{{ data.FARMERID}}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="ແຈ້ງເຕືອນ ທີ່ຮັບຮູ້ແລ້ວ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ລາຍການ ແຈ້ງເຕືອນ ທີ່ຮັບຮູ້ແລ້ວ">
              </b-field>
              <b-field>
                <table
                  class="table is-fullwidth is-narrow is-small"
                >
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="2%">#</th>
                      <th class="has-text-left " width="10%">
                        ວັນທີຕັ້ງຄ່າ
                      </th>
                      <th class="has-text-left " width="10%">
                        ວັນທີແຈ້ງເຕືອນ
                      </th>
                      <th class="has-text-left " width="10%">
                        ວັນທີມີຜົນ
                      </th>
                      <th class="has-text-left " width="40%">
                        ລາຍລະອຽດ
                      </th>
                      <th class="has-text-left " width="10%">
                        ຊາວກະສິກອນ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in plantnotiknown"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ dateFormatter(data.SETUPDATE) }}
                      </td>
                      <td>
                        {{  dateFormatter(data.NOTIDATE) }}
                      </td>
                      <td>
                        {{  dateFormatter(data.EFFECTDATE) }}
                      </td>
                      <td class="has-text-left">
                        {{ data.REMARK }}
                      </td>
                      <td>
                        {{ data.FARMNAME }}<br>{{ data.FARMERID}}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
// import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  // components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
    roleid: null,
    userName: null,
    activeTab: 1,
    plantnotisetup: [],
    plantnotisend: [],
    plantnotiknown: [],
    selectedeffectdate : null,
    selectednotidate: null,
    notiremark : null,
 
    };
  },
  methods: {
    getPlantNoti(){
      RestAPI.getPlantNoti(3, this.userProvinceID)
        .then(res => {
          console.log("res:" + JSON.stringify(res.data))
          this.plantnotisetup = res.data.plantnotisetup;
          this.plantnotisend = res.data.plantnotisend;
          this.plantnotiknown = res.data.plantnotiknown;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    saveWeatherNoti(){
    // console.log("this.selecteddate: " + this.dateFormatterYYYYMMDD(this.selecteddate))
    // console.log("this.selectedopentime: " + this.selectedopentime.TIME)
      if (this.selectedeffectdate === null || this.selectednotidate === null || this.notiremark === null ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } else {
        var params = {
          notitype: 3,
          provinceid: this.userProvinceID,
          setupdate: this.dateFormatterYYYYMMDD(new Date().toISOString().slice(0, 10)),
          effectdate: this.dateFormatterYYYYMMDD(this.selectedeffectdate),
          notidate: this.dateFormatterYYYYMMDD(this.selectednotidate),
          notiremark: this.notiremark,
          username: this.username
        };
        console.log("params: ", JSON.stringify(params))
        RestAPI.saveWeatherNoti(params)
          .then(() => {
  
            this.$swal("ເພີ່ມເວລາ ສຳເລັດ!", "", "success");
            
            this.selectedeffectdate = new Date();
            this.selectednotidate = new Date();
            this.notiremark = null;
            this.getPlantNoti();
            this.activeTab = 1;
          })
          .catch(error => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
   },
    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },

    print() {
      window.print();
    }
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.userProvinceID = this.user.BRANCHPROVNICEID 
    this.getPlantNoti();
    this.selectedeffectdate = new Date();
    this.selectednotidate = new Date();

  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.section-title{
  margin-top:10px;
  font-size: 20;
  font-weight: bold;
  text-decoration: underline;
}
.asterisk{
  color: red;
}
</style>